// src/components/StatusBadge.js
import React from 'react';

const KNOWN = ['Approved', 'Rejected', 'Reviewed', 'Pending'];

export default function StatusBadge({ status, size = 'sm' }) {
  const variant = KNOWN.includes(status) ? status.toLowerCase() : 'default';
  const cls = `badge badge--${variant}${size === 'lg' ? ' badge--lg' : ''}`;
  return <span className={cls}>{status}</span>;
}
